import { useState } from 'react';

const testimonials = [
  {
    name: 'Todd H.',
    location: "St. Mary's, GA",
    text: "Josh is still very responsive two years later — he came back, reworked our gates completely, and we couldn't be happier. We've recommended Masters Fencing to several people. If you're looking for quality craftsmanship, you've found it.",
    rating: 5,
    service: 'Wood Privacy Fence',
    initials: 'TH',
  },
  {
    name: 'Jessica S.',
    location: "St. Mary's, GA",
    text: "The owner and his crew went above and beyond. Their work is absolutely beautiful — kind, patient, great rates. My husband and I will use Masters Fencing for any future projects. Everything was flawless and we are beyond thankful.",
    rating: 5,
    service: 'Wood Fence Installation',
    initials: 'JS',
  },
  {
    name: 'Anthony C.',
    location: 'Camden County, GA',
    text: 'Quick to respond, very competitive pricing — the fence was hand-built with top quality materials. Team ripped out the old fencing, installed the new one, and cleaned up in half a day. Very pleased with the results.',
    rating: 5,
    service: 'Fence Replacement',
    initials: 'AC',
  },
  {
    name: 'Kimberly C.',
    location: "St. Mary's, GA",
    text: "Josh spent time going over every option and made sure we were involved in each step. Very polite and professional, work was done quickly and extremely well. We are very pleased with the entire project.",
    rating: 5,
    service: 'Custom Fencing',
    initials: 'KC',
  },
  {
    name: 'Toni K.',
    location: "King's Bay, GA",
    text: 'Great job with attention to quality over quickness. He showed me different choices, gave honest advice, and did a complete walk-through when done. Happy to do minor repair work post-install. Would highly recommend.',
    rating: 5,
    service: 'Wood Fence',
    initials: 'TK',
  },
  {
    name: 'Debbie R.',
    location: 'Camden County, GA',
    text: 'Josh and his crew installed over 400 ft of board-on-board fencing around our yard. Unbeatable work ethic and the end result is remarkable. We love supporting this local business and will recommend to all neighbors.',
    rating: 5,
    service: '400ft Board-on-Board Fence',
    initials: 'DR',
  },
];

const TestimonialsSection: React.FC = () => {
  const [activeIdx, setActiveIdx] = useState(0);

  const visibleSet = [
    testimonials[activeIdx % testimonials.length],
    testimonials[(activeIdx + 1) % testimonials.length],
    testimonials[(activeIdx + 2) % testimonials.length],
  ];

  return (
    <section
      className="relative overflow-hidden"
      style={{ background: 'linear-gradient(165deg, #0D0C0B 0%, #181410 55%, #0D0C0B 100%)' }}
    >
      {/* Decorative top accent */}
      <div className="gold-separator" />

      {/* Large decorative quote mark */}
      <div className="absolute top-16 right-12 font-serif text-[220px] text-white/[0.025] leading-none pointer-events-none select-none">
        &ldquo;
      </div>

      <div className="section-py max-w-7xl mx-auto px-6 relative z-10">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-16 gap-6 reveal">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="gold-bar" />
              <span className="text-[#C4A84F] text-[11px] tracking-[0.38em] uppercase font-sans font-medium">
                Client Stories
              </span>
            </div>
            <h2 className="font-serif text-[3.2rem] md:text-[4.2rem] text-[#F5F1E8] leading-[0.95]">
              What Camden County<br />Homeowners Say
            </h2>
          </div>
          <div className="flex flex-col gap-2 items-start md:items-end">
            <div className="flex gap-1.5">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="fa-solid fa-star text-[#C4A84F] text-sm" />
              ))}
            </div>
            <span className="text-[#F5F1E8]/35 text-sm font-sans">Perfect 5.0 · Google Reviews</span>
          </div>
        </div>

        {/* 3-card grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-14 stagger">
          {visibleSet.map((t, i) => (
            <article
              key={`${t.name}-${i}`}
              className={`reveal flex flex-col relative overflow-hidden ${
                i === 1
                  ? 'bg-[#C4A84F] md:-mt-5 md:-mb-5'
                  : 'bg-white/[0.04] border border-white/8 hover:border-[#C4A84F]/28 transition-all duration-400'
              }`}
            >
              <div className="p-8 flex-1 flex flex-col">
                {/* Stars */}
                <div className="flex gap-1 mb-6">
                  {[...Array(t.rating)].map((_, si) => (
                    <i
                      key={si}
                      className={`fa-solid fa-star text-xs ${i === 1 ? 'text-[#0D0C0B]/50' : 'text-[#C4A84F]'}`}
                    />
                  ))}
                </div>

                {/* Quote */}
                <blockquote
                  className={`font-serif text-[1.1rem] leading-relaxed flex-1 mb-8 italic ${
                    i === 1 ? 'text-[#0D0C0B]/90' : 'text-[#F5F1E8]/80'
                  }`}
                >
                  &ldquo;{t.text}&rdquo;
                </blockquote>

                {/* Attribution */}
                <div className={`flex items-center gap-4 pt-5 border-t ${i === 1 ? 'border-[#0D0C0B]/15' : 'border-white/8'}`}>
                  {/* Initials circle */}
                  <div className={`w-10 h-10 flex items-center justify-center font-sans font-bold text-sm shrink-0 ${
                    i === 1 ? 'bg-[#0D0C0B]/15 text-[#0D0C0B]' : 'bg-[#C4A84F]/15 text-[#C4A84F]'
                  }`}>
                    {t.initials}
                  </div>
                  <div>
                    <div className={`font-sans font-semibold text-sm ${i === 1 ? 'text-[#0D0C0B]' : 'text-[#F5F1E8]'}`}>
                      {t.name}
                    </div>
                    <div className={`text-xs font-sans mt-0.5 ${i === 1 ? 'text-[#0D0C0B]/50' : 'text-[#F5F1E8]/30'}`}>
                      {t.location} · {t.service}
                    </div>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* Navigation + CTA row */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 pt-10 border-t border-white/8 reveal">
          {/* Dots + arrows */}
          <div className="flex items-center gap-6">
            <div className="flex gap-2">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActiveIdx(i)}
                  className={`cursor-pointer transition-all duration-300 h-[3px] ${
                    i === activeIdx ? 'w-10 bg-[#C4A84F]' : 'w-4 bg-white/18 hover:bg-white/35'
                  }`}
                  aria-label={`Testimonial set ${i + 1}`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => setActiveIdx((p) => (p - 1 + testimonials.length) % testimonials.length)}
                className="w-10 h-10 flex items-center justify-center border border-white/12 text-[#F5F1E8]/60 hover:bg-[#C4A84F] hover:border-[#C4A84F] hover:text-[#0D0C0B] transition-all cursor-pointer"
                aria-label="Previous testimonial"
              >
                <i className="fa-solid fa-chevron-left text-xs" />
              </button>
              <button
                onClick={() => setActiveIdx((p) => (p + 1) % testimonials.length)}
                className="w-10 h-10 flex items-center justify-center border border-white/12 text-[#F5F1E8]/60 hover:bg-[#C4A84F] hover:border-[#C4A84F] hover:text-[#0D0C0B] transition-all cursor-pointer"
                aria-label="Next testimonial"
              >
                <i className="fa-solid fa-chevron-right text-xs" />
              </button>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col sm:flex-row items-center gap-5">
            <p className="font-serif text-[1.4rem] text-[#F5F1E8]/55 italic">
              Join hundreds of satisfied homeowners.
            </p>
            <a href="#estimate" className="btn-gold shrink-0">
              <i className="fa-regular fa-calendar-check text-[11px]" />
              Get My Free Estimate
            </a>
          </div>
        </div>
      </div>

      <div className="gold-separator" />
    </section>
  );
};

export default TestimonialsSection;
